import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './pages/Login';

ReactDOM.render(
  <React.StrictMode>
    <Login />
  </React.StrictMode>,
  document.getElementById('root')
);

